import { Subject } from "rxjs";
import { logE } from "@blacknut/logging/dist";
import { apiService, TAG } from "../../ApiService";
import { BoostStatus } from "./boostStatus";

const _poll = (isCanceled: () => boolean, subject: Subject<BoostStatus>) => {
  setTimeout(() => {
    apiService
      .get<{ status: BoostStatus }>({
        path: `v1/store/ericsson/boost`,
        requiresAuthPolicy: "user",
      })
      .subscribe({
        next: (refreshed) => {
          subject.next(refreshed.status);
          _poll(isCanceled, subject);
        },
        error: (err: any) => {
          logE(TAG, "Caught error getting status", err);
          _poll(isCanceled, subject);
        },
      });
  }, 5000);
};
export const pollBoost = () => {
  let canceled = false;
  const subject = new Subject<BoostStatus>();
  const res = {
    cancel: () => {
      canceled = true;
    },
    onChange: () => subject.asObservable(),
  };
  apiService
    .get<{ status: BoostStatus }>({
      path: `v1/store/ericsson/boost`,
      requiresAuthPolicy: "user",
    })
    .subscribe({
      next: (res) => {
        subject.next(res.status);
        _poll(() => canceled, subject);
      },
      error: (err: any) => {
        logE(TAG, "Caught error getting status", err);
        subject.next(BoostStatus.REFUSED);
        _poll(() => canceled, subject);
      },
    });
  return res;
};
